<template>
    <div v-if="$cordova.instance" :class="$style.container">
        <template v-if="isTrackable">
            <template v-if="isActive">
                <span style="animation-delay: 0s" :class="[$style.badge, $style.animated, $style.ok]" />
                <span style="animation-delay: 1s" :class="[$style.badge, $style.animated, $style.ok]" />
                <span style="animation-delay: 2s" :class="[$style.badge, $style.animated, $style.ok]" />
                <span style="animation-delay: 3s" :class="[$style.badge, $style.animated, $style.ok]" />
            </template>
            <template v-else-if="!isLazy">
                <span :class="[$style.badge, $style.ok]" />
            </template>
            <template v-else>
                <a-tooltip placement="left">
                    <template slot="title">
                        <span>🌎 No está en línea</span>
                    </template>
                    <span :class="[$style.badge, $style.ko]" />
                </a-tooltip>
            </template>
        </template>
        <template v-else>
            <span :class="[$style.badge, $style.disable]" />
        </template>
    </div>
</template>

<script>
import Vue from 'vue'

export default {
    name: 'BackgroundTask',
    data() {
        return {
            watcher: null,
            config: {
                distanceDiff: 1000,
                timeTrackFrom: '00:00',
                timeTrackTo: '00:00',
            },
            lastPosition: null,
            lastJob: 946684800,
            isActive: false,
            time: this.$moment(),
            markers: [],
        }
    },
    computed: {
        isTrackable() {
            if (this.$cordova.instance) {
                const beforeTime = this.$moment(`${this.config.timeTrackFrom}:00`, 'hh:mm:ss')
                const afterTime = this.$moment(`${this.config.timeTrackTo}:00`, 'hh:mm:ss')
                if (this.time.isBetween(beforeTime, afterTime, 'hour', '[]') && this.$gestios.profile.Group.ID === 8)
                    return true
            }

            return true
        },
        isLazy() {
            const a = this.$moment()
            const b = this.lastJob
            const diff = a.diff(b, 'minutes')

            if (diff > 10) return true
            return false
        },
    },
    watch: {
        markers: {
            async handler(newVal) {
                const newPosition = newVal[0].position

                const newFullPosition = `${newPosition.lat},${newPosition.lng}`
                const oldFullPosition = this.lastPosition ? `${this.lastPosition.lat},${this.lastPosition.lng}` : ''

                if (newFullPosition !== oldFullPosition) {
                    let pass = false

                    if (this.lastPosition) {
                        const diff = this.distanceDiff(
                            newPosition.lat,
                            newPosition.lng,
                            this.lastPosition.lat,
                            this.lastPosition.lng
                        )

                        if (diff >= this.config.distanceDiff) {
                            const timestampDiff = newVal[0].others.timestamp - this.lastPosition.timestamp
                            if (timestampDiff >= 30) pass = true
                        }
                    } else {
                        pass = true
                    }

                    if (pass) {
                        this.lastPosition = {
                            lat: newVal[0].position.lat,
                            lng: newVal[0].position.lng,
                            accuracy: newVal[0].others.accuracy,
                            elevation: newVal[0].others.elevation,
                            speed: newVal[0].others.speed,
                            timestamp: newVal[0].others.timestamp,
                        }

                        const result = await this.$store.dispatch('addPosition', this.lastPosition)

                        if (result) {
                            this.isActive = true
                            this.lastJob = this.$moment()
                        } else {
                            this.isActive = false
                            this.lastJob = 946684800
                        }
                    }
                }
            },
            deep: true,
        },
        isActive(val) {
            if (val) {
                setTimeout(() => {
                    this.isActive = false
                }, 3000)
            }
        },
    },
    async created() {
        // const self = this;

        // CARGAMOS CONFIG
        const config = await this.$gestios.config.list(Object.keys(this.config))
        if (config.ok) {
            Object.keys(config.data).forEach((key) => {
                this.config[key] = config.data[key]
            })
        }

        document.addEventListener('deviceready', () => {
            setInterval(() => {
                this.time = this.$moment()
                if (this.isTrackable) {
                    if (this.watcher === null) {
                        this.startTrack()
                    }
                } else if (this.watcher) {
                    this.stopTrack()
                }
            }, 5000)
        })
    },
    methods: {
        stopTrack() {
            navigator.geolocation.clearWatch(this.watcher)
            this.watcher = null
        },
        startTrack() {
            // const self = this;

            this.watcher = navigator.geolocation.watchPosition(
                async (position) => {
                    this.markers = [
                        {
                            position: {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude,
                            },
                            others: {
                                accuracy: position.coords.accuracy,
                                elevation: position.coords.altitude,
                                speed: position.coords.speed,
                                timestamp: position.timestamp,
                            },
                        },
                    ]
                },
                (error) => {
                    this.showMessage(`Error #${error.code} ${error.message}`, 'danger')
                },
                {
                    timeout: 5000,
                    enableHighAccuracy: true,
                }
            )
        },
        distanceDiff(lat1, lon1, lat2, lon2) {
            const R = 6371
            const dLat = ((lat2 - lat1) * Math.PI) / 180
            const dLon = ((lon2 - lon1) * Math.PI) / 180

            const a =
                Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos((lat1 * Math.PI) / 180) *
                    Math.cos((lat2 * Math.PI) / 180) *
                    Math.sin(dLon / 2) *
                    Math.sin(dLon / 2)

            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
            const d = R * c

            return Math.round(d * 1000)
        },
    },
}
</script>

<style lang="scss" module>
.container {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.badge {
    position: absolute;
    width: 15px;
    height: 15px;
    display: block;
    border-radius: 50%;
}

.animated {
    opacity: 0;
    animation: scaleIn 2s infinite cubic-bezier(0.36, 0.11, 0.89, 0.32);
}

.ok {
    background: $success;
}

.ko {
    background: $danger;
}

.disable {
    background: $gray-6;
}

@keyframes scaleIn {
    from {
        transform: scale(0.5, 0.5);
        opacity: 0.5;
    }
    to {
        transform: scale(2.5, 2.5);
        opacity: 0;
    }
}
</style>
